import { ConfiguratorConfig, ConfigurationsRegistry } from '@icc/configurator/types';
import { WindowActiveConfiguration } from './window-active-configuration';
import { WindowConfiguration } from './window-configuration';
import { DoorActiveConfiguration } from './door-active-configuration';
import { DoorConfiguration } from './door-configuration';
import { HSActiveConfiguration } from './hs-active-configuration';
import { HSConfiguration } from './hs-configuration';
import { SlidingDoorActiveConfiguration } from './sliding-door-active-configuration';
import { SlidingDoorConfiguration } from './sliding-door-configuration';
import { FoldingDoorActiveConfiguration } from './folding-door-active-configuration';
import { FoldingDoorConfiguration } from './folding-door-configuration';
import { ComplementaryGoodsActiveConfiguration } from './complementary-goods-active-configuration';
import { ComplementaryGoodsConfiguration } from './complementary-goods-configuration';

export const WINDOW_CONFIGURATOR_CONFIG: ConfiguratorConfig = {
    type: 'window',
    activeConfigurationClass: WindowActiveConfiguration,
    configurationClass: WindowConfiguration
};

export const DOOR_CONFIGURATOR_CONFIG: ConfiguratorConfig = {
    type: 'door',
    activeConfigurationClass: DoorActiveConfiguration,
    configurationClass: DoorConfiguration
};

export const HS_CONFIGURATOR_CONFIG: ConfiguratorConfig = {
    type: 'hs',
    activeConfigurationClass: HSActiveConfiguration,
    configurationClass: HSConfiguration
};

export const SLIDING_DOOR_CONFIGURATOR_CONFIG: ConfiguratorConfig = {
    type: 'sliding_door',
    activeConfigurationClass: SlidingDoorActiveConfiguration,
    configurationClass: SlidingDoorConfiguration
};

export const FOLDING_DOOR_CONFIGURATOR_CONFIG: ConfiguratorConfig = {
    type: 'folding_door',
    activeConfigurationClass: FoldingDoorActiveConfiguration,
    configurationClass: FoldingDoorConfiguration
};

export const COMPLEMENTARY_GOODS_CONFIGURATOR_CONFIG: ConfiguratorConfig = {
    type: 'complementary_goods',
    activeConfigurationClass: ComplementaryGoodsActiveConfiguration,
    configurationClass: ComplementaryGoodsConfiguration
};

/**
 * Rejestruje wszystkie konfiguracje window-door w Registry
 * Używane przez frontend (Angular module) i backend (APP_INITIALIZER)
 */
export function registerWindowDoorConfigurations(): void {
    ConfigurationsRegistry.register(WINDOW_CONFIGURATOR_CONFIG);
    ConfigurationsRegistry.register(DOOR_CONFIGURATOR_CONFIG);
    ConfigurationsRegistry.register(HS_CONFIGURATOR_CONFIG);
    ConfigurationsRegistry.register(SLIDING_DOOR_CONFIGURATOR_CONFIG);
    ConfigurationsRegistry.register(FOLDING_DOOR_CONFIGURATOR_CONFIG);
    ConfigurationsRegistry.register(COMPLEMENTARY_GOODS_CONFIGURATOR_CONFIG);
}
